module.exports = __webpack_public_path__ + "static/media/lauren-hudson-avatar.a93c5127.jpg";